import type { ReactNode } from 'react';
import {
  folderStateWord,
  jobWaitingLine,
  lastFileLine,
  quietLine,
  sentTodayWords,
} from './folder-words';
import type { PaigeWatchedFolder } from './paige.global';

/**
 * The job's watched folder as Paige last heard of it: the computer, the path, its state word and any
 * problem in the computer's own words, the last file, what went today, and a quiet computer said
 * plainly. Changing it happens on that computer, in Paige Scan's Watched folders window.
 */
export function WatchedFolderCard({ folder }: { folder: PaigeWatchedFolder }): ReactNode {
  const quiet = quietLine(folder);
  const waiting = jobWaitingLine(folder);
  return (
    <div className="paige-scan-unavailable" role="status">
      <strong>
        {folder.device} · {folderStateWord(folder.state)}
      </strong>
      <p>
        <code>{folder.path}</code>
      </p>
      {folder.problem && <p className="paige-scan-problem">{folder.problem}</p>}
      {waiting && <p>{waiting}</p>}
      <p>
        {lastFileLine(folder)} {sentTodayWords(folder.sentToday)}.
      </p>
      {quiet && <p className="paige-scan-problem">{quiet}</p>}
      <small className="paige-scan-alt">
        To change or remove it, open Paige Scan on {folder.device} and choose Watched folders.
      </small>
    </div>
  );
}
